module.exports = __webpack_public_path__ + "img/progress.b786d81a.png";